import Vue from 'vue'
import { Component, Prop, Watch } from 'vue-property-decorator'
import PageNavigationBar from '@appbase/components/Paginate/PageNavigationBar.vue'
import { openPopup } from '@appbase/util/popup-helper'
import { LoadingBar } from '@appbase/components/loading'

@Component({
    components: { PageNavigationBar, LoadingBar }
})
export default class SearchResultBoard extends Vue {
    @Prop({type:Array}) articleList!: article.Article[]
    @Prop({type:Number}) articleCount!: number
    @Prop({type:Number}) currentPage!: number
    @Prop({type:Number}) pageSize!: number
    @Prop({type:String}) userLang!: string
    @Prop({type:Boolean, default: true}) isLoading!: boolean

    loading: boolean = true;

    // PageNavigation Click Event
    fnMovePage(number: number){
        this.$emit("onPaging", number, this.pageSize);
    }

    fnVieArticle(articleId: number, boardId: number){
        openPopup('', `/BoardPopup/readPopup?SYSID=${boardId}&ARTICLEID=${articleId}`, {}, {
            width: 1024,
            height: 700,
        });
    }

    fnDisplayDate(date: Date){
        let dtDate = new Date(date);
        return dtDate.toISOString().slice(0, 10);
    }

    getImage(article: article.Article) {
        if(article.hasImage) {
            return `/cm/Portal/Article/api/thumbnail?fileName=${encodeURIComponent(article.imageFilePath)}`;            
        } else {
            var divElem = document.createElement('div');
            divElem.innerHTML = article.content;

            var imageSource = divElem.querySelector('img')?.src;

            if(imageSource) {
                return imageSource;
            } else {
                return "/cm/gres/images/img_not_found.jpg";
            }        
        }                
    }

    @Watch('isLoading')
    onIsLoadingChanged(newVal: boolean, oldVal: boolean) {
        this.loading = this.isLoading;
    }
}